import React from 'react';
import { motion } from 'framer-motion';
import { BRAND_COLOR } from '../constants';

const About: React.FC<{ isDarkMode: boolean }> = ({ isDarkMode }) => (
  <section id="about" className={`py-32 border-t transition-colors duration-500 ${isDarkMode ? 'bg-black border-white/5' : 'bg-white border-zinc-100'}`}>
    <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-20 items-center">
      <motion.div 
        initial={{ opacity: 0, x: -30 }} 
        whileInView={{ opacity: 1, x: 0 }} 
        transition={{ duration: 0.8 }}
        viewport={{ once: true }} 
        className={`aspect-[4/5] overflow-hidden border group transition-colors duration-500 ${isDarkMode ? 'bg-zinc-900 border-white/10' : 'bg-zinc-50 border-zinc-200'}`}
      >
        <img 
          src="https://res.cloudinary.com/dxvma4lwc/image/upload/v1764577510/PhotoElyk_dmpirk.png" 
          className="w-full h-full object-cover transition-transform duration-[2s] group-hover:scale-110" 
          alt="Artist Profile" 
        />
      </motion.div>
      <div>
        <motion.p 
          initial={{ opacity: 0, x: -10 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className={`font-black tracking-[0.4em] uppercase text-[13px] mb-6 transition-colors duration-500 ${isDarkMode ? 'text-white' : 'text-black'}`}
        >
          Est 2017 Boston, MA
        </motion.p>
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className={`font-display text-5xl md:text-8xl font-black uppercase mb-10 leading-[0.9] transition-colors duration-500 ${isDarkMode ? 'text-white' : 'text-black'}`}
        >
          CRAFTING <br /> <span style={{ color: BRAND_COLOR }}>IMPACT.</span>
        </motion.h2>
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          viewport={{ once: true }}
          className={`text-xl md:text-2xl font-black uppercase leading-relaxed mb-16 transition-colors duration-500 ${isDarkMode ? 'text-white' : 'text-black'}`}
        >
          Based in Boston, specializing in high-contrast urban portraiture and dynamic studio narratives. We don't just take pictures; we define visual edges for world-class brands.
        </motion.p>
        
        <div className="space-y-12">
          <motion.div
             initial={{ opacity: 0, y: 20 }}
             whileInView={{ opacity: 1, y: 0 }}
             transition={{ delay: 0.3 }}
             viewport={{ once: true }}
          >
            <h4 className={`font-black uppercase tracking-[0.3em] text-[13px] mb-8 transition-colors ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>Core Metrics</h4>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
              <div>
                <p style={{ color: BRAND_COLOR }} className="font-display text-5xl md:text-6xl font-black italic tracking-tighter mb-1">07</p>
                <p className={`text-[12px] font-black tracking-[0.2em] uppercase ${isDarkMode ? 'text-white' : 'text-black'}`}>Years Exp.</p>
              </div>
              <div>
                <p style={{ color: BRAND_COLOR }} className="font-display text-5xl md:text-6xl font-black italic tracking-tighter mb-1">200+</p>
                <p className={`text-[12px] font-black tracking-[0.2em] uppercase ${isDarkMode ? 'text-white' : 'text-black'}`}>Projects</p>
              </div>
              <div className="col-span-2 md:col-span-1">
                <p style={{ color: BRAND_COLOR }} className="font-display text-5xl md:text-6xl font-black italic tracking-tighter mb-1">150K+</p>
                <p className={`text-[12px] font-black tracking-[0.2em] uppercase ${isDarkMode ? 'text-white' : 'text-black'}`}>Frames Captured</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  </section>
);

export default About;